(function() {
  'use strict';

  angular
    .module('eclipseApp.components')
    .constant('geoip2', window.geoip2)

    .controller('uteHeaderCtrl', [
      '$scope',
      'uteLocale',
      'cartManager',
      'util',
      '$rootScope',
      '$timeout',
      'promptService',
      'userPrefService',
      '$state',
      'commonService',
      '$window',
      '$sessionStorage',
      'uteModal',
      'janrainService',
      'provinceService',
      '$filter',
      'viewInvoice',
      'brtSwitchCMS',
      function(
        $scope,
        uteLocale,
        cartManager,
        util,
        $rootScope,
        $timeout,
        promptService,
        userPrefService,
        $state,
        commonService,
        $window,
        $sessionStorage,
        uteModal,
        janrainService,
        provinceService,
        $filter,
        viewInvoice,
        brtSwitchCMS
      ) {
        /**
         * TODO - comment
         */
        $scope.getQuantity = cartManager.getQuantity;

        /**
         * TODO - comment
         * @type {$sessionStorage|*}
         */
        $scope.$storage = $sessionStorage;
        $scope.isHybridFlow = !brtSwitchCMS.brtSwitch.isHybridFlow;

        /**
         * reference to the the shoppingCart
         */
        //$scope.shoppingCart = $rootScope.shoppingCart;

        /**
         * TODO - comment
         */
        $scope.currentRouteName = '';

        /**
         * toggle menu method
         */
        $scope.toggleMobileNav = function(e) {
          e.preventDefault();
          $rootScope.ruiMethods.toggleMobileMenu();
        };

        /**
         * TODO - comment
         */
        $scope.headerTypeClass = function() {
          return $scope.headerType;
        };

        $scope.fadeHeaderClass = function() {
          return $scope.fadeHeader;
        };

        $scope.fadeoutPositionClass = function() {
          return $scope.fadeoutPosition;
        };

        /**
         * login user into app
         */
        $scope.login = function() {
          console.log('LOGIN!!!');
          janrainService.renderLogin();
        };

        /**
         * log out user from app
         */
        $scope.logout = function() {
          console.log('LOGOUT!!!');
          //Write any login cleanup code in 'self.logOut' function in commonService
          $scope.$storage.$reset();

          $state.go('logout');
        };

        /**
         * TODO - comment
         */
        $scope.headerType = 'default';

        $scope.fadeHeader = '';

        $scope.fadeoutPosition = '';
        /**
         * TODO - comment
         */
        $scope.$on('rciLoginStatusChange', function(response, result) {
          console.log('response', result);
        });

        $scope.getMyaccountLink = function() {
          if ($rootScope.userInfo.isAccountLinked === false) {
            return 'linkAccounts';
          } else {
            return 'myAccount.overview';
          }
        };

        //$scope.fadeHeader = function (){
        //var scrollReturn = false;
        $(window).scroll(function() {
          if ($(this).scrollTop() < 65.6) {
            //DSO-15057 scroll fix on confirmation page
            if (
              $state.current &&
              $state.current.name === 'confirmation' &&
              $state.current.parent === 'buy' &&
              ($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent())
            ) {
              if ($rootScope.ruiMethods.user.is.agent()) {
                $('body').removeClass('remove-body-extra-space-confirmation');
                if ($rootScope.ruiMethods.showMyAccountLink()) {
                  $('body').addClass('body-extra-spacing');
                }
              } else {
                $('body').addClass('body-extra-spacing');
              }
              //$('.create-profile-menu-holder').css({'position': 'fixed'});
            }
            $scope.$apply(function() {
              $scope.fadeHeader = '';
              $scope.fadeoutPosition = '';
            });
          } else {
            if (
              ($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) &&
              $state.current.data &&
              $state.current.data.showSubHeading === true
            ) {
              //DSO-15057 scroll fix on confirmation page
              if ($state.current.name === 'confirmation' && $state.current.parent === 'buy') {
                if ($rootScope.ruiMethods.user.is.agent()) {
                  $('body').addClass('remove-body-extra-space-confirmation');
                  $('body').removeClass('body-extra-spacing');
                } else {
                  $('body').removeClass('body-extra-spacing');
                }
                // $('.create-profile-menu-holder').css({'position': 'static'});
              }
              $scope.$apply(function() {
                $scope.fadeHeader = 'fadeout';
                $scope.fadeoutPosition = 'fadeOutPosition';
              });
            } else {
              $scope.$apply(function() {
                $scope.fadeHeader = '';
                $scope.fadeoutPosition = '';
              });
            }
          }
        });

        //return scrollReturn;

        //};

        /**
         * TODO - comment
         */
        $rootScope.$on('$stateChangeSuccess', function(event, toState) {
          $state.current = toState;
          $scope.isHybridFlow = !brtSwitchCMS.brtSwitch.isHybridFlow;
          $scope.currentRouteName = $state.current.name;
          if ($scope.currentRouteName === 'cartSummary' && $rootScope.rgPopoverScope) {
            $rootScope.rgPopoverScope.disable();
          } else if ($scope.currentRouteName !== 'cartSummary' && $rootScope.rgPopoverScope) {
            $rootScope.rgPopoverScope.enable();
          }
        });

        // use pure javascript to read the cookie
        var getCookieJS = function(cname) {
          var name = cname + '=';
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
          }
          return '';
        };

        $timeout(function() {
          var prov = 'ON';

          console.log(
            'F.S >>>>>>>>> province cookie read by $ and JS = ' +
              $window.getCookie('province', false) +
              ' : ' +
              getCookieJS('province')
          );

          //if ($window.getUserPrefCookie('firstTimeUser')) {
          // select province when there is no setProvince from querystring, and the legacy cookie province is not setup
          //if (window.__userPref.getUserPref && !$window.getCookie('province', false)) {
          if (util.getParameterByName('rs') === 'rps' || util.getParameterByName('rs') === 'verifyEmail') {
            if (util.detectBrowser().type === 'safari') {
              var is_private = false;
              try {
                window.localStorage.setItem('private', 1);
              } catch (e) {
                is_private = true;
                //alert('You are in Privacy Mode\nPlease deactivate Privacy Mode and then reload the page.'); //TODO add message to en/fr.json modal template will refer it.
                uteModal.open({
                  templateUrl: 'modules/user/views/private-error-modal.html',
                  ok: function() {}
                });
                return;
              }
              window.localStorage.removeItem('private');
            }
          }
          if (window.__userPref.getUserPref && !getCookieJS('province')) {
            geoip2.city(
              function(data) {
                prov = data.subdivisions[0].iso_code.toUpperCase();
                if (util.detectBrowser().type !== 'safari') {
                  promptService.promptUser(prov);
                } else {
                  // for safari
                  uteLocale.actualProvince = prov;
                }
              },
              function() {
                if (util.detectBrowser().type !== 'safari') {
                  promptService.promptUser(prov);
                }
              }
            );
          } else {
            if (util.detectBrowser().type !== 'safari') {
              promptService.checkNextAction();
            }
          }
        });

        //Update Billing & Payment link based on the selected Account

        $scope.updateBillingPaymentsLink = function(accountNumber) {
          console.log('billing payment link');
          if ((commonService.accountDetails || []).length > 0) {
            var accountDetail = _.find(commonService.accountDetails, function(accountDetail) {
              return (
                accountDetail.accountNumber &&
                !accountDetail.fraud &&
                !($rootScope.ruiMethods.user.is.agent() && accountDetail.hasWireless) &&
                accountDetail.accountNumber === accountNumber
              );
            });
            if (accountDetail && accountDetail.LOB == 'WLPP' && !$rootScope.ruiMethods.user.is.agent()) {
              $scope.billingPaymentsLink = {
                enable: true,
                type: 'prepaid'
              };
            } else if (accountDetail && accountDetail.LOB != 'WLPP') {
              $scope.billingPaymentsLink = {
                enable: true,
                type: 'regular',
                accountNumber: accountDetail.accountNumber
              };
            } else {
              $scope.billingPaymentsLink = {
                enable: false
              };
            }
          } else {
            $scope.billingPaymentsLink = {
              enable: false
            };
          }
        };

        $scope.redirectToOverview = function(accountNumber) {
          $state.go('myAccount.overview', {
            accountNumber: accountNumber
          });
        };

        $scope.updateState = function(accountNumber) {
          var stateName = '';
          $scope.accountNumberSelected = accountNumber;
          _.each(commonService.accountDetails, function(accountDetail) {
            if (accountDetail.accountNumber == $scope.accountNumberSelected) {
              var subscriberNo = '',
                stateAccountNumber = '';
              stateAccountNumber = accountDetail.accountNumber;
              if (accountDetail.fraud || accountDetail.hasError) {
                $scope.redirectToOverview(accountDetail.accountNumber);
              } else if (
                /*--------------------------------------Dashboard Pages-----------------------------------------------*/
                ($state.current.name == 'myAccount.wireless' ||
                  $state.current.name == 'myAccount.prepaidWLDashboard' ||
                  $state.current.name == 'myAccount.internet') &&
                ((accountDetail.accountStatus && accountDetail.accountStatus.toLowerCase() === 'open') ||
                  !_.isEmpty(accountDetail.subscriberServices))
              ) {
                if (accountDetail.hasWireless) {
                  stateName =
                    accountDetail.LOB && accountDetail.LOB.toUpperCase() === 'WLPP' ? 'prepaidWLDashboard' : 'wireless';
                  subscriberNo = accountDetail.subscriberServices[0].wireless.subscriberNo;
                  $state.go('myAccount.' + stateName, {
                    accountNumber: accountNumber,
                    subscriberNo: subscriberNo
                  });
                } else if (accountDetail.hasInternet) {
                  subscriberNo = accountDetail.subscriberServices[0].internet.subscriberNo;
                  $state.go('myAccount.internet', {
                    accountNumber: accountNumber,
                    subscriberNo: subscriberNo
                  });
                } else {
                  $scope.redirectToOverview(accountDetail.accountNumber);
                }
              } else if (
                /*-----------------------------------------Billing pages-----------------------------------------------*/
                $state.current.name == 'myAccount.viewInvoice' ||
                $state.current.name == 'myAccount.billingAndPayments'
              ) {
                if (accountDetail.hasWireless && accountDetail.LOB && accountDetail.LOB.toUpperCase() === 'WLPP') {
                  $state.go('myAccount.billingAndPayments', { accountNumber: accountNumber });
                } else if (
                  accountDetail.LOB &&
                  (accountDetail.LOB.toUpperCase() === 'WL' || accountDetail.LOB.toUpperCase() === 'C')
                ) {
                  viewInvoice.clearList();
                  $state.go('myAccount.viewInvoice', { accountNumber: accountNumber });
                }
              } else if ($state.current.name == 'myAccount.viewProfile') {
                /*--------------------------------------------Profile Page--------------------------------------------------*/
                $state.go($state.current.name, { accountNumber: accountNumber });
              } else {
                /*----------------------------------------------Rest Of The Pages-------------------------------------------*/
                $scope.redirectToOverview(accountDetail.accountNumber);
              }
            }
          });
        };

        $scope.accountSelected = function(accountNumber) {
          $scope.showAccountsDropdown = false;
          $scope.selectedAccountNumber = accountNumber;
          $rootScope.userInfo.selectedAccountNumber = $scope.selectedAccountNumber;
          $scope.updateState($scope.selectedAccountNumber);
        };

        $scope.showNavLinkSection = function(section) {
          if (typeof section != 'undefined' && section == 'accounts') {
            $scope.screenToRender = 'showAccountSection';
            $scope.showAccountSection = true;
            $scope.showNavLinks = false;
          } else if (typeof section != 'undefined' && section == 'links') {
            $scope.screenToRender = 'showNavLinks';
            $scope.showAccountSection = false;
            $scope.showNavLinks = true;
          }
          uteModal.open({
            templateUrl: 'modules/components/views/mobile-nav-links.html',
            controller: 'uteHeaderCtrl',
            scope: $scope,
            windowClass: 'popup modal-pop-up',
            size: 'md',
            backdrop: 'static',
            ok: function() {},
            cancel: function() {}
          });
        };

        $scope.showAccountList = function(accountList) {
          $scope.closeBillinandPaymentDropDown();
          if (typeof accountList !== 'undefined' && accountList === 'hideAccounts') {
            $scope.showAccountsDropdown = false;
            $scope.showServices = false;
          } else {
            $scope.showServices = false;
            if ($scope.showAccountsDropdown) {
              $scope.showAccountsDropdown = false;
            } else {
              $scope.showAccountsDropdown = true;
            }
          }
        };

        $scope.loadBBIFrame = function() {
          if ($state.current.name === 'myAccount.viewInvoice') {
            $rootScope.$broadcast('view-invoice-header'); // broadcasting event to re-load brite bill IFrame on click of this link
          }
        };

        $scope.showServiceList = function() {
          $scope.showAccountsDropdown = false;
          if ($scope.showServices) {
            $scope.showServices = false;
          } else {
            $scope.showServices = true;
          }
        };

        $scope.billinAndPaymentsToggle = function() {
          if ($scope.showServices) {
            $scope.showServices = false;
          }
          $scope.showBillinandPaymentsList = !$scope.showBillinandPaymentsList;
          $scope.screenToRender = 'showBillingAndPaymentSection';
        };

        $scope.closeBillinandPaymentDropDown = function() {
          $scope.showBillinandPaymentsList = false;
        };

        $scope.openServices = function(action) {
          if (typeof action != 'undefined' && action == 'hide') {
            $scope.screenToRender = 'showNavLinks';
          } else {
            $scope.screenToRender = 'showServiceSection';
          }
        };
        $scope.skipToMainContent = function(event) {
          event.preventDefault();
          event.stopPropagation();
          if ($(window).width() < 768) {
            $('.overview-icon').attr('tabindex', '0');
            $('.overview-icon').focus();
          } else {
            $('#skipNavigationAngular').attr('tabindex', '0');
            $('#skipNavigationAngular').focus();
          }
        };
        $scope.blurAccessible = function() {
          if ($(window).width() < 768) {
            $('#header .navbar-header, #nav-actions').removeClass('accessible-navbar');
            $('#skipNavigationAngularMob').removeClass('accessible-sub-navbar');
            $('#skipNavigationAngularMob').attr('tabindex', '-1');
          } else {
            $('#skipNavigationAngular').attr('tabindex', '-1');
          }
        };
        $scope.focusAccessible = function() {
          if ($(window).width() < 768) {
            $('#header .navbar-header, #nav-actions').addClass('accessible-navbar');
            $('#skipNavigationAngularMob').addClass('accessible-sub-navbar');
          }
        };
        //key board event handling for accessibility remediation
        setTimeout(function() {
          $('li#search').bind('keydown', function(e) {
            if (e.which === 13) {
              $('li#search a').click();
            }
          });
          $('li#shopcart').bind('keydown', function(e) {
            if (e.which === 13) {
              $('li#shopcart a').click();
            }
          });
          $('li#shop-cart a').bind('keydown', function(e) {
            if (e.which === 13) {
              $('li#shop-cart a').click();
            }
          });
          $('li#province').bind('keydown', function(e) {
            if (e.which === 13) {
              $('li#province a.dropdown-toggle').click();
            }
          });
        }, 3000);

        $scope.languageToggle = function() {
          uteLocale.language = uteLocale.language === 'en' ? 'fr' : 'en';
        };

        $scope.saveProvince = function(province) {
          // if province of choice is the same as current province, don't proceed with the change
          if (province.toLowerCase() === uteLocale.province.toLowerCase()) {
            return false;
          }

          // check if province is being called from the directive or outside
          if (angular.isUndefined(province)) {
            province = uteLocale.province.toLowerCase();
          } else {
            province = province.toLowerCase();
          }

          // first check if the shopping cart is empty; prompt user if it isn't
          if (cartManager.getQuantity() > 0) {
            uteModal.open({
              title: $filter('translate')('global.label.changeProvinceWarning'),
              message: $filter('translate')('global.message.changeProvinceWarning'),
              okButtonLabel: $filter('translate')('global.cta.continue'),
              cancelButtonLabel: $filter('translate')('global.cta.cancel'),
              ok: function() {
                provinceService.checkFootPrint(province).then(
                  function(province) {
                    provinceService.update(province);
                  },
                  function(province) {
                    //$scope.selectedProvince = province;
                  }
                );
              },
              cancel: function() {
                //$scope.selectedProvince = uteLocale.province;
              }
            });
            return;
          }

          // if the cart is empty
          provinceService.checkFootPrint(province).then(
            function(province) {
              provinceService.update(province);
            },
            function(province) {
              //$scope.selectedProvince = province;
            }
          );
        };
      }
    ]);
})();
